import Image from "next/image";
import Head from "next/head";
import styles from "../tnpsc-group-i-prelims-test/tnpsc-group-i-prelims-test.module.css";
import Navbar from "../../components/Navbar/Navbar";
import Footer from "../../components/Footer/Footer";
import dynamic from "next/dynamic";
const Interest = dynamic(() => import("../../components/might-be-interest"));
import Banner from "../../assets/images/Tnpsc/TNPSC-Gr-I-Prelims-BII-Web-banner.jpg";
import MobBanner from "../../assets/images/Tnpsc/TNPSC-Gr-I-Prelims-BII-Mobile-banner.jpg";
import Link from "next/link";
import { useEffect, useState } from 'react';
import { useRouter } from "next/router";

const Tnpsc_Group_One_Prelims_Test_series = () => {

    const router = useRouter();
    
      useEffect(() => {
        const handleRouteChange = (url) => {
          console.log(`Navigated to ${url}`);
          router.reload(); // Refresh the page on route change
        };
    
        router.events.on("routeChangeComplete", handleRouteChange);
    
        // Cleanup on component unmount
        return () => {
          router.events.off("routeChangeComplete", handleRouteChange);
        };
    }, [router]);

const feestructure3 =[
         {center:"AnnaNagar",mode:( <> <div>Batch III - (Offline) </div></>),start:"5th Feb 2026", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div><Link href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GroupI-PrelimsTest-2026/Anna-nagar/Offline-IMTOP-2026-TNPSC-GROUP-I-PRELIMS-TEST-BATCH3.pdf" target="_blank" className={`${styles.paybill}`}>Offline Click here</Link></div> </>),
            pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
                {center:"AnnaNagar",mode:( <> <div>Batch III - (Online) </div></>),start:"5th Feb 2026", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div><Link href="https://www.shankariasacademy.com/pdf/TNPSC-2026/Tnpsc-GroupI-PrelimsTest-2026/Anna-nagar/Online-IMTOP-2026-TNPSC-GROUP-I-PRELIMS-TEST-BATCH3.pdf" target="_blank" className={`${styles.paybill}`}>Online Click here</Link></div> </>),
            pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
        {center:"AnnaNagar",mode:( <> <div>Batch II - (Offline) </div></>),start:"3rd Jan 2026", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div><Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/anna-nagar/Tnpsc-Gr1-PrelimsTest-Annanagar-B2-Offline-2025.pdf" target="_blank" className={`${styles.paybill}`}>Offline Click here</Link></div> </>),
            pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=ANNA_NAGAR&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},       

        {center:"Online",mode:( <> <div>Batch II - ( Online) </div></>),start:"3rd Jan 2026", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div className=""><Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/anna-nagar/Tnpsc-Gr1-PrelimsTest-Annanagar-B2-Online-2025.pdf" target="_blank" className={`${styles.paybill} `}>Online Click here</Link></div></>),
            pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=ONLINE TEST BATCH&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},                   
        

        {center:"AnnaNagar",mode:( <> <div>Batch I - (Offline) </div></>),start:"17th Dec 2025", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div><Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/anna-nagar/Tnpsc-Gr1-PrelimsTest-Annanagar-B1-Offline-2025.pdf" target="_blank" className={`${styles.paybill}`}>Offline Click here</Link></div> </>),
            pay :(<a href="#" target="_blank" rel="noopener noreferrer">
                Admission Closed</a>)},       

        {center:"Online",mode:( <> <div>Batch I - ( Online) </div></>),start:"17th Dec 2025", 
            fee:(<><div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>), 
          cont3:(<><div className=""><Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/anna-nagar/Tnpsc-Gr1-PrelimsTest-Annanagar-B1-Online-2025.pdf" target="_blank" className={`${styles.paybill} `}>Online Click here</Link></div></>),
            pay :(<a href="#" target="_blank" rel="noopener noreferrer">
                    Admission Closed</a>)},                   

        {center:"Adyar",mode:( <> <div>Batch I - Offline </div>  </>),start:"22nd Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/Adyar/Tnpsc-Gr1-PrelimsTest-Adyar-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Adyar&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
      
        {center:"Thiruvarur",mode:( <> <div>Batch I - Offline </div> </>),start:"22nd Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/Thiruvarur/Tnpsc-Gr1-PrelimsTest-Thiruvarur-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Thiruvarur&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
        
        {center:"Coimbatore",mode:( <> <div>Batch I - Offline </div>  </>),start:"23rd Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com//pdf/Tnpsc-GroupI-PrelimsTest-2025/Coimbatore/Tnpsc-Gr1-PrelimsTest-Coimbatore-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Covai&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
       
        {center:"Madurai",mode:( <> <div>Batch I - Offline </div>  </>),start:"24th Dec 2025", 
            fee:( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com/pdf/Tnpsc-GroupI-PrelimsTest-2025/Madurai/TNPSC-GRP1-Prelims-B1-Madurai.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Madurai&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  

        {center:"Namakkal",mode:( <> <div>Batch I - Offline </div>  </>),start:"26th Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com//pdf/Tnpsc-GroupI-PrelimsTest-2025/Namakkal/Tnpsc-Gr1-PrelimsTest-Namakkal-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Namakkal&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
        
        {center:"Salem",mode:( <> <div>Batch I - Offline </div> </>),start:"26th Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com//pdf/Tnpsc-GroupI-PrelimsTest-2025/Salem/Tnpsc-Gr1-PrelimsTest-Salem-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Salem&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  

        {center:"Trichy",mode:( <><div>Batch I - Offline </div> </>),start:"28th Dec 2025", 
            fee: ( <> <div>₹8,500 (For Old students)</div>  <div>₹9,500 (For New Students)</div> </>),  
          cont3:<Link href="https://www.shankariasacademy.com//pdf/Tnpsc-GroupI-PrelimsTest-2025/Trichy/Tnpsc-Gr1-PrelimsTest-Trichy-B1-2025.pdf" target="_blank" className={`${styles.paybill}`}>Click here</Link>,
           pay :(<a href="https://admissionsv1.shankariasacademy.com/?center=Trichy&coursetype=TNPSC" target="_blank" rel="noopener noreferrer">
                    <button className={`${styles.normalbutton1} btn btn-danger`}> Pay Now</button></a>)},  
        
        ]  

    return (
        <>
        <Head>
            <meta charset="UTF-8" />
            <meta name="viewport" content="width=device-width, initial-scale=1" />
            <meta name="robots" content="noodp,noydir" />
            <meta name="robots" content="index,follow" />
            <meta name="robots" content="index, follow, max-image-preview:large, max-snippet:-1, max-video-preview:-1" />
            <meta property="article:publisher" content="https://www.facebook.com/shankariasacademy" />
            <meta property="article:modified_time" content="2024-01-25T05:43:44+00:00" />
            <title>TNPSC Group 1 Prelims Test Series 2026 | I’M TOP – Shankar IAS Academy</title>
            <meta name="title" content=" TNPSC Group 1 Prelims Test Series 2026 | I’M TOP – Shankar IAS Academy" />
            <meta name="description" content="Join Shankar IAS Academy’s TNPSC Group 1 Prelims I’M TOP Test Series 2026. Pattern-based mock tests, detailed analysis and expert mentoring across centres in Tamil Nadu. Pre-book your slot today." />
            <meta name="keywords" content="TNPSC Group I Prelims 2026, TNPSC Group 1 Test Series 2026, I’M TOP Test Series, Shankar IAS Academy TNPSC, TNPSC Group 1 Mock Test, TNPSC Group I Preparation 2026, TNPSC Group I Online Test Series, TNPSC Group I Coaching, TNPSC Group I Study Materials, TNPSC 2026 Prelims Test"/>
            <link rel="canonical" href="https://www.shankariasacademy.com/tnpsc-group-i-prelims-test/" />
            <meta property="og:locale" content="en_US" />
            <meta property="og:type" content="article" />
            <meta property="og:title" content="TNPSC Group 1 Prelims Test Series 2026 | I’M TOP – Shankar IAS Academy" />
            <meta property="og:description" content="Join Shankar IAS Academy’s TNPSC Group 1 Prelims I’M TOP Test Series 2026. Pattern-based mock tests, detailed analysis and expert mentoring across centres in Tamil Nadu. Pre-book your slot today." />
            <meta property="og:url" content="https://www.shankariasacademy.com/tnpsc-group-i-prelims-test/" />
            <meta property="og:site_name" content="Shankar IAS Academy" />
            <meta name="twitter:card" content="summary_large_image" />
            <meta name="twitter:site" content="@shankarias" />
            <script>{`var s=document.createElement("script"); s.type="text/javascript"; s.async=true; s.src="https://widgets.in6.nopaperforms.com/emwgts.js"; document.body.appendChild(s); `}</script>
        </Head>

        <Navbar title="tnpsc" />

        <div className="container pb-4">
            <div className="row">
                <div className="col pt-md-4">
                    <h1 className={`${styles.pagemaintitle}`} style={{color:"#7f0801"}}>TNPSC Group 1 Prelims Test Series 2026 – I’M TOP Programme</h1>
                </div>
            </div>
            <div className="row d-none d-md-block">
                <div className="col pt-3 pt-md-2">
                    <Image src={Banner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
                </div>
            </div>

            <div className="row d-block d-md-none">
                <div className="col pt-3 pt-md-5">
                    <Image src={MobBanner} alt="tnpsc-group-i-prelims-test banner" title="TNPSC Group I Prelims Test" className="img-fluid w-100"/>
                </div>
            </div> 
        </div>


        {/* <div className="container-fluid pb-5"  style={{background: "linear-gradient(to top, rgba(255, 242, 242, 0.8), rgb(182, 238, 255 , 29%))",opacity: "1", }}>           */}
            {/* <div className={`${styles.coursesimg} mb-2`}>
                <div class="col-12 col-md-5 offset-md-4 mt-4">
                    <p className={`${styles.contactheader} text-center`}><b>Enquiry</b></p>
                    <p className={`${styles.acheiverrank} text-center mb-0 `}>kindly fill out the form below. We will get in touch with you shortly.</p>
                    <div class={`${styles.addmissionform} npf_wgts mt-2`} data-height="550px" data-w="3f4274baec4df825dd72c5ff92d085ff"> </div> 
                </div>
            </div> */}

       {/* table */}
          <section  id="courseandfees">
                <div className="container pt-xl-4" >
                    <div className="row">
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Center</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Mode</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Starts on</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Fee</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Schedule</div>
                        <div className={`${styles.tableheading} col-12 col-md-2 d-none d-md-block d-lg-block`} style={{ backgroundColor: "#7f0801" }}>Payment</div>
                        <hr/>
                    </div>
                    
                    {feestructure3.map((item,index)=>(
                        <div className={`${styles.facultyborder3} row`}>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Center</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.center}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Mode</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0  pb-md-3`}>{item.mode}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Starts on</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.start}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Fee</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.fee}</div>
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Schedule</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-0 text-center pt-2 pt-md-0`}>{item.cont3}</div>                       
                        <div className={`${styles.tabvalue} col-4 d-md-none d-xs-block pt-2`}>Payment</div>
                            <div className={`${styles.classacheiverrank} col-8 col-md-2 mb-2 text-center pt-2 pt-md-2`}>
                              {item.pay}
                            </div>
                        <hr/>

                        </div>
                    ))} 
                    
                </div>
	       </section> 

           <div className="container-fluid py-5" style={{background:"linear-gradient(to top, rgba(248,207,227,0), rgba(255,223,186,0.5))",}}>
            <div className="container">
                <div className="row justify-content-center">
                <div className="col-lg-12 ">
                    <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
                        <p className={`${styles.coursepara} mb-3 `}>
                            If you are serious about TNPSC Group 1, your marks are decided long before the exam – in how you test, analyse, and correct yourself.
                        </p>

                        <p className={`${styles.coursepara} mb-3`}>
                            Shankar IAS Academy’s <strong>I’M TOP – TNPSC Group 1 Prelims Test Series 2026</strong> is built exclusively for Group 1 Prelims, featuring pattern-based mock tests, detailed explanations, and centre-based offline practice across Tamil Nadu.
                        </p>

                        <p className={`${styles.coursepara} mb-0`}>
                            Whether you are a first-time aspirant or a repeater, this test series helps you identify gaps early, improve accuracy, and walk into the exam hall with a clear, confident strategy.
                        </p>

                        <p className={`${styles.coursepara} pt-4`} style={{color:"#7f0801"}}>Pre-Book Your TNPSC Group 1 Prelims 2026 Test Series Slot</p>
                        <p className={`${styles.coursepara} mb-3 `}>Seats are limited at each centre and batches fill on a first-come, first-served basis. Pre-book now and our team will help you choose the right centre and batch based on your current preparation level.</p>
                    </div>
                </div>

                <div className="col-lg-12 pt-4">
                    <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
                       <h2 className={`${styles.pagemaintitle} `} style={{color:"#7f0801"}}>Why Choose Shankar IAS Academy’s TNPSC Group 1 Prelims I’M TOP Test Series?</h2>
                   
                        <p className={`${styles.coursepara} mb-3 `}>
                           * TNPSC-first design – Test papers are created strictly around the TNPSC Group 1 Prelims syllabus and pattern, not generic GS mocks.
                        </p>

                        <p className={`${styles.coursepara} mb-3`}>
                           * Structured to build exam stamina – Offline tests in a real exam-like setting to sharpen time management and question selection.
                        </p>

                        <p className={`${styles.coursepara} mb-3`}>
                          * Clear performance feedback – Answer keys, explanations and comparative ranking so you know exactly where you stand.
                        </p>

                        <p className={`${styles.coursepara} mb-3`}>
                           * Mentor guidance – Faculty and mentors available for doubt clarification and guidance on how to improve weak areas.
                        </p>

                        <p className={`${styles.coursepara} mb-3`}>
                           * Disciplined preparation – A fixed test calendar that forces consistent revision instead of last-minute scrambling.
                        </p>
                    </div>
                </div>

                 <div className="col-lg-12 pt-4">
                    <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
                       <h2 className={`${styles.pagemaintitle} `} style={{color:"#7f0801"}}>What You Get in the I’M TOP Test Series</h2>
                   
                        <h6 className={`${styles.pagesubtitle} fw-semibold mb-1`}>
                            ● Planned set of tests
                        </h6>

                        <p className="mb-0 ps-5" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                            A structured series of full-length and topic-wise tests covering the complete TNPSC Group 1 Prelims syllabus.
                        </p>

                        <h6 className={`${styles.pagesubtitle} fw-semibold mb-1 pt-3`}>
                            ● Syllabus coverage
                        </h6>

                        <p className="mb-0 ps-5" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ General Studies – History, Polity, Economy, Geography, Science, Current Affairs
                        </p>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ Aptitude & Mental Ability
                        </p>

                        <h6 className={`${styles.pagesubtitle} fw-semibold mb-1 pt-3`}>
                            ● Mode & medium
                        </h6>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                          Tests conducted offline at designated centres, in the medium specified by the academy (update as per actual Tamil / English policy).
                        </p>

                        <h6 className={`${styles.pagesubtitle} fw-semibold mb-1 pt-3`}>
                            ● Evaluation & analysis
                        </h6>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ OMR-based evaluation (for offline tests)
                        </p>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ Rank lists and performance comparison with other aspirants
                        </p>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ Identification of strong and weak areas
                        </p>

                        <h6 className={`${styles.pagesubtitle} fw-semibold mb-1 pt-3`}>
                            ● Support after tests
                        </h6>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ Answer keys and brief explanations
                        </p>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                           ○ Guidance on revision strategy and how to use test results for improvement
                        </p>

                        <h2 className={`${styles.pagemaintitle} pt-2`} style={{color:"#7f0801"}}>TNPSC Group 1 Prelims Test Series Schedule & Centres</h2>

                        <p className="mb-0 ps-5 pt-1" style={{fontFamily: "Switzer-Medium",fontSize: "16px",lineHeight: "24px",}}>
                          Choose the centre and batch that best fits your convenience. The I’M TOP – TNPSC Group 1 Prelims Test Series 2026 is conducted across our key centres in Tamil Nadu, with a common, pre-planned schedule.
                        </p>

                    </div>
                </div>

                <div className="col-lg-12 pt-4">
                    <div className="bg-white rounded-4 shadow-sm p-4 p-md-5">
                        <h2 className={`${styles.pagemaintitle} mb-4`} style={{ color: "#7f0801" }}>
                           FAQs – TNPSC Group 1 Prelims (I’M TOP) Test Series 2026
                        </h2>

                        <div className="accordion accordion-flush" id="imtTopFAQ">
                            {/* FAQ 1 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button className="accordion-button collapsed fw-semibold" type="button" data-bs-toggle="collapse" data-bs-target="#faqOne" >
                                   1. How many TNPSC Group 1 Prelims mock tests are included in this test series?
                                </button>
                                </h2>
                                <div id="faqOne" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                    The I’M TOP test series includes a planned set of full-length and topic-wise tests from the start date up to the prelims. The exact number of tests and dates is given in the schedule table on this page
                                </div>
                                </div>
                            </div>

                            {/* FAQ 2 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faqTwo"
                                >
                                    2. Are the questions aligned with the latest TNPSC Group 1 Prelims pattern?
                                </button>
                                </h2>
                                <div id="faqTwo" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                    Yes. The test papers are designed according to the latest TNPSC Group 1 Prelims syllabus and pattern, with the right mix of static subjects and current affairs.
                                </div>
                                </div>
                            </div>

                            {/* FAQ 3 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faqThree"
                                >
                                    3. Will I receive explanations and answer keys after each test?
                                </button>
                                </h2>
                                <div id="faqThree" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                    Yes. After every test, you will receive answer keys and explanations so that you can understand your mistakes and revise the concepts properly.
                                </div>
                                </div>
                            </div>

                            {/* FAQ 4 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faqFour"
                                >
                                    4. Is this an offline or online test series?
                                </button>
                                </h2>
                                <div id="faqFour" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                   This test series is primarily conducted offline at our centres as per the schedule. If any online component is available, it will be clearly mentioned at the time of registration.
                                </div>
                                </div>
                            </div>

                            {/* FAQ 5 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faqFive"
                                >
                                   5. Which centres are available for the TNPSC Group 1 Prelims test series?
                                </button>
                                </h2>
                                <div id="faqFive" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                    The test series is offered at major centres in Tamil Nadu such as Anna Nagar (Chennai), Adyar (Chennai), Coimbatore, Madurai, Namakkal, Salem, Trichy and Thiruvarur, subject to batch availability
                                </div>
                                </div>
                            </div>

                             {/* FAQ 6 */}
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faq6"
                                >
                                   6. Is this test series suitable for working professionals?
                                </button>
                                </h2>
                                <div id="faq6" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                    The test series is offered at major centres in Tamil Nadu such as Anna Nagar (Chennai), Adyar (Chennai), Coimbatore, Madurai, Namakkal, Salem, Trichy and Thiruvarur, subject to batch availability
                                </div>
                                </div>
                            </div>

                            {   /* FAQ 7 */ }

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faq7"
                                >
                                   7. Can I change my centre or batch after registration?
                               </button>
                                </h2>
                                <div id="faq7" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                   Centre or batch changes depend on seat availability and academy rules. You can contact your centre or our support team to check if a change is possible.
                                </div>
                                </div>
                            </div>

                            {   /* FAQ 8 */ }
                            
                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faq8"
                                >
                                  8. What is the fee for the TNPSC Group 1 Prelims I’M TOP Test Series 2026?
                                </button>
                                </h2>
                                <div id="faq8" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                   Fees may vary by centre and batch. Please refer to the Fee column in the schedule table or contact your nearest centre for exact details.
                                </div>
                                </div>
                            </div> 

                             { /* FAQ 8 */ } 

                            <div className="accordion-item">
                                <h2 className="accordion-header">
                                <button
                                    className="accordion-button collapsed fw-semibold"
                                    type="button"
                                    data-bs-toggle="collapse"
                                    data-bs-target="#faq9"
                                >
                                  9.How can I get additional guidance along with the test series?
                                </button>
                                </h2>
                                <div id="faq9" className="accordion-collapse collapse" data-bs-parent="#imtTopFAQ">
                                <div className="accordion-body">
                                  You can interact with mentors and faculty at the centre, attend post-test discussions (where scheduled) and use the performance analysis to plan subject-wise and revision-wise improvements.
                                </div>
                                </div>
                            </div>  
                        </div>

                        <p className="mt-2 pt-3" style={{ fontFamily: "Switzer-Medium", fontSize: "16px", lineHeight: "24px" }}>
                           The TNPSC Group 1 Prelims I’M TOP Test Series 2026 is conducted across our centres in Anna Nagar (Chennai), Adyar (Chennai), Coimbatore, Madurai, Namakkal, Salem, Trichy and Thiruvarur. Choose the centre closest to you and practise in an exam-like environment before the actual prelims.
                        </p>

                    </div>
                </div>
                </div>                  
                </div>
            </div>
       
        {/* </div> */}

        <Interest />
        <Footer />
        </>
    )
}
export default Tnpsc_Group_One_Prelims_Test_series;
